module.exports = __webpack_public_path__ + "media/images/metal_gold-3597488d.png";